<template>
<form @submit.prevent="onsubmit">
  <va-input
    v-model="email"
    type="email"
    :label="$t('auth.email')"
    :error="!!emailErrors.length"
    :error-messages="emailErrors"
  />

  <va-input
    v-model="password"
    type="password"
    :label="$t('auth.password')"
    :error="!!passwordErrors.length"
    :error-messages="passwordErrors"
  />

  <div class="auth-layout__options d-flex align--center justify--space-between">
    <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/>
    <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
  </div>

  <div class="d-flex justify--center mt-3">
    <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
  </div>
</form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
import userService from '../../../api/userService'
import store from '../../../store/index'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    async onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }
      try {
        store.commit('setLoading', true)
        var authentication = await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        var user = authentication.user
        var token = await user.getIdToken(true)
        await userService.get(user.email, user.emailVerified, user.uid, token)
        if (user.emailVerified) {
          this.$router.replace({ name: 'open' })
        } else {
          this.$router.replace({ name: 'change-password' })
        }
      } catch (error) {
        this.password = ''
        this.showToast(error.message, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      store.commit('setLoading', false)
    },
  },
}
</script>

<style lang="scss">
</style>
